import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createDatedPlanModalOpenSelector,
  createNewTemplateModalOpenSelector,
  selectPlanModalOpenSelector,
} from "../../../reducers/ownApp/selectors";
import {
  setCreateDatedPlanModalOpen,
  setCreateNewTemplateModalOpen,
  setSelectedRoute,
} from "../../../reducers/ownApp";
import { getSelectedMatrixProfile } from "../../../reducers/matrixProfile/selectors";
import { setMatrixProfileOptions } from "../../../reducers/matrixProfile/thunkActions";

import { Modal } from "../Modal";
import { CreatePlan } from "../CreatePlan/CreatePlan";
import { SelectPlanModalActions } from "./SelectPlanModalActions";
import { SelectPlanModalContent } from "./SelectPlanModalContent";

export const SelectPlanModal = ({ open, onClose }) => {
  const selectedProfile = useSelector(getSelectedMatrixProfile);
  const [value, setValue] = useState();

  const selectPlanModalOpen = useSelector(selectPlanModalOpenSelector);

  const createNewTemplateModalOpen = useSelector(
    createNewTemplateModalOpenSelector
  );
  const createDatedPlanModalOpen = useSelector(
    createDatedPlanModalOpenSelector
  );

  const dispatch = useDispatch();

  const onPlanSelected = (plan) => {
    setValue(plan);
  };

  useEffect(() => {
    if (selectPlanModalOpen) {
      setValue(null);
    }
  }, [selectPlanModalOpen]);

  const onApply = () => {
    dispatch(setSelectedRoute());
    dispatch(setMatrixProfileOptions({ key: "profile", value }));
    onClose && onClose();
  };

  useEffect(() => {
    if (!value && selectedProfile) {
      setValue(selectedProfile);
    }
  }, [value, selectedProfile]);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={"Select Plan"}
        content={
          <SelectPlanModalContent
            onPlanSelected={onPlanSelected}
            selectedPlan={value}
          />
        }
        actions={
          <SelectPlanModalActions
            onApply={onApply}
            onCreateDatePlan={() => {
              dispatch(setCreateDatedPlanModalOpen(true));
            }}
            onCreateNewTemplate={() => {
              dispatch(setCreateNewTemplateModalOpen(true));
            }}
            selectedValue={value}
          />
        }
        minWidth={500}
      />
      <CreatePlan
        open={createNewTemplateModalOpen || createDatedPlanModalOpen}
        isDatedPlan={createDatedPlanModalOpen}
      />
    </>
  );
};

export default SelectPlanModal;
